import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { optionsBranch } from "../data/branch-data";
import { generateStatus } from "../utils/generateDisplay";
import { 
  getInternshipRequestById, 
  getLogbookById, 
  getInternReportById, 
  getProposalById, 
  getCoopReportById, 
  getInternManualById,
  updateRatingLogbook,
  updateRatingInternManual,
  updateRatingProposal,
  getTotalScoreOnly,
  getAssessment,
  getAssessment_report,
  getAssessmentCoop,
  getAssessment_presentcoop,
  getAssessment_companycoop,
  getAssessment_reportcoop,
  getCoopReportDetail
} from "../api/crud";
import { Box, Container, Typography, Paper, Grid, IconButton, Stack, Rating, Tooltip, Button, Dialog, DialogTitle, DialogContent, DialogActions, Chip, LinearProgress, Badge } from "@mui/material";
import { Assignment, PictureAsPdf, LocationOn, FactCheck, CheckCircle, Email, Visibility, ContentCopy, Psychology, Close, OpenInNew, PersonPin } from "@mui/icons-material";
import { updateSnackbar } from "../redux/action/dataAction";
import { engApi } from "../api/engApi";
import useMediaQuery from "@mui/material/useMediaQuery";

const StudentEvaluation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const internRequestId = searchParams.get('req_id');
  const isMobile = useMediaQuery('(max-width:767px)');

  const [isLoading, setIsLoading] = useState(false);
  const [profileDetail, setProfileDetail] = useState(null);
  const [logbookDetail, setLogbookDetail] = useState([]);
  const [internReportDetail, setInternReportDetail] = useState([]);
  const [proposalDetail, setProposalDetail] = useState([]);
  const [coopReportDetail, setCoopReportDetail] = useState([]);
  const [coopReportProjectTitle, setCoopReportProjectTitle] = useState('');
  const [internManualDetail, setInternManualDetail] = useState([]);
  const [ratings, setRatings] = useState({});
  const [totalScoreCompany, setTotalScoreCompany] = useState(null);
  const [copiedLogbooks, setCopiedLogbooks] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisResults, setAnalysisResults] = useState(null);
  const [showAnalysisDialog, setShowAnalysisDialog] = useState(false);
  const [auditor, setAuditor] = useState(null);

  const currentYear = new Date().getFullYear() + 543;
  
  const convertDateThai = (dateString, includeTime = true) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const thaiYear = date.getFullYear() + 543;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return includeTime ? `${day}/${month}/${thaiYear}` : `${day}/${month}/${thaiYear}`;
  };

  const bodymail = `เรียน ผู้ดูแล/พี่เลี้ยงนิสิตฝึกงาน \n 
ตามที่${profileDetail?.cp_name} ได้รับ ${profileDetail?.st_name} รหัสนิสิต ${profileDetail?.st_id} สาขาวิชา ${optionsBranch?.find((el) => el.value == profileDetail?.b_id)?.label}
จากคณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา เข้าฝึกงานและสหกิจศึกษาปี ${parseInt(currentYear)+1} ระหว่างวันที่ ${convertDateThai(profileDetail?.start_date,false)} - ${convertDateThai(profileDetail?.end_date,false)} นั้น

ทางคณะวิศวกรรมศาสตร์ขอความกรุณาท่านประเมินผลการฝึกงาน 2 เดือนของนิสิตดังกล่าว โดยกรอกแบบประเมินผ่านลิงค์ต่อไปนี้:
https://forms.gle/DLXTMLhqMqRKxQpe8
  
หากท่านมีข้อสงสัยหรือต้องการข้อมูลเพิ่มเติม กรุณาติดต่องานสหกิจศึกษา คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา 
ที่เบอร์โทรศัพท์ 038-102222 ต่อ 3315 หรืออีเมล co-op@eng.buu.ac.th
ขอขอบคุณในความร่วมมือของท่านมา ณ โอกาสนี้

ขอแสดงความนับถือ
งานสหกิจศึกษา ฝ่ายพัฒนานิสิต
คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา`;

  const bodymailcoop = `เรียน ผู้ดูแล/พี่เลี้ยงนิสิตฝึกงาน \n 
ตามที่${profileDetail?.cp_name} ได้รับ ${profileDetail?.st_name} รหัสนิสิต ${profileDetail?.st_id} สาขาวิชา ${optionsBranch?.find((el) => el.value == profileDetail?.b_id)?.label}
จากคณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา เข้าฝึกงานและสหกิจศึกษาปี ${parseInt(currentYear)+1} ระหว่างวันที่ ${convertDateThai(profileDetail?.start_date,false)} - ${convertDateThai(profileDetail?.end_date,false)} นั้น

ทางคณะวิศวกรรมศาสตร์ขอความกรุณาท่านประเมินผลประเมินผลการปฏิบัติสหกิจศึกษาและรายงานโครงงานสหกิจศึกษาของนิสิตดังกล่าว 
โดยกรอกแบบประเมินผ่านลิงค์ต่อไปนี้:
1) ENG-Coop C003 แบบประเมินผลการปฏิบัติสหกิจศึกษา
https://forms.gle/NLHrMfzV2gxJ9TtA9

2) ENG-Coop C004 แบบประเมินผลรายงานสหกิจศึกษา
https://forms.gle/N6ERsj2NFBxrKVMa6

  
หากท่านมีข้อสงสัยหรือต้องการข้อมูลเพิ่มเติม กรุณาติดต่องานสหกิจศึกษา คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา 
ที่เบอร์โทรศัพท์ 038-102222 ต่อ 3315 หรืออีเมล co-op@eng.buu.ac.th
ขอขอบคุณในความร่วมมือของท่านมา ณ โอกาสนี้

ขอแสดงความนับถือ
งานสหกิจศึกษา ฝ่ายพัฒนานิสิต
คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา`;

  // AI Analysis function
  const analyzeWithAI = async () => {
    if (!logbookDetail || logbookDetail.length === 0) {
      dispatch(updateSnackbar({
        isOpen: true,
        message: "ไม่พบข้อมูล logbook ที่จะวิเคราะห์",
        severity: "warning"
      }));
      return;
    }

    setIsAnalyzing(true);
    
    // Test mode - ถ้าไม่มี n8n server ให้ใช้ mock data
    const isTestMode = process.env.REACT_APP_N8N_TEST_MODE === 'true';
    
    const payload = {
      student_id: profileDetail?.st_id,
      student_name: profileDetail?.st_name,
      req_id: profileDetail?.req_id,
      logbook_links: logbookDetail.map(logbook => logbook.link).filter(link => link),
      metadata: {
        branch: optionsBranch?.find(el => el.value === profileDetail?.b_id)?.label,
        company: profileDetail?.cp_name,
        supervisor: profileDetail?.supervisorName,
        gpa: profileDetail?.GPA
      }
    };
    
    try {
      let insights;
      
      if (isTestMode) {
        // Mock response สำหรับทดสอบ
        await new Promise(resolve => setTimeout(resolve, 2000)); // จำลอง delay
        insights = {
          student_id: payload.student_id,
          student_name: payload.student_name,
          internship: {
            company: payload.metadata.company,
            role: "Test Product Engineer",
            duration: { start_date: "", end_date: "" }
          },
          tech_stack: ["AI", "Object Detection", "C#", "GitHub", "Video capture"],
          tasks: [
            { summary: "ฟังชี้แจงรายละเอียดของงาน และข้อบังคับต่าง ๆ (orientation)", evidence_word: [] },
            { summary: "เข้าร่วมการเขียน technical paper, ส่งเอกสาร, รับเสื้อ และ Pre-test Exam", evidence_word: [] },
            { summary: "อบรม Introduction และเดินดู Process line", evidence_word: [] }
          ],
          skills: [
            { name: "C#", category: "programming", level: "", evidence_word: "" },
            { name: "AI / Model training", category: "programming", level: "", evidence_word: "" },
            { name: "GitHub", category: "tools", level: "", evidence_word: "" }
          ],
          soft_skills: [
            { name: "Teamwork", level: "", evidence_word: "" },
            { name: "Communication", level: "", evidence_word: "" }
          ],
          outcomes: [
            { type: "deliverable", detail: "ส่งงาน Assignment 2", evidence_word: [] },
            { type: "report", detail: "จัดทำ Project Charter และ Gantt chart เบื้องต้น", evidence_word: [] }
          ],
          notes: "ผู้ฝึกงานทำงานในแผนก Test Product Engineer โดยรับผิดชอบโปรเจ็ค Object detection model (นี่คือข้อมูลทดสอบ)"
        };
      } else {
        // n8n webhook URL - update this to match your n8n server
        const n8nWebhookUrl = process.env.REACT_APP_N8N_WEBHOOK_URL || 'http://localhost:5678/webhook/analyze-logbooks';
        
        const response = await fetch(n8nWebhookUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        insights = await response.json();
      }
      
      setAnalysisResults(insights);
      setShowAnalysisDialog(true);
      
      dispatch(updateSnackbar({
        isOpen: true,
        message: "วิเคราะห์ด้วย AI สำเร็จ!",
        severity: "success"
      }));
      
    } catch (error) {
      let errorMessage = 'เกิดข้อผิดพลาดในการวิเคราะห์';
      
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        errorMessage = 'ไม่สามารถเชื่อมต่อ n8n server ได้ โปรดตรวจสอบ URL และการตั้งค่า';
      } else if (error.message.includes('CORS')) {
        errorMessage = 'CORS Error: ตั้งค่า CORS ใน n8n server ไม่ถูกต้อง';
      } else {
        errorMessage = `เกิดข้อผิดพลาด: ${error.message}`;
      }
      
      dispatch(updateSnackbar({
        isOpen: true,
        message: errorMessage,
        severity: "error"
      }));
    } finally {
      setIsAnalyzing(false);
    }
  };

  // Get skill category color
  const getSkillCategoryColor = (category) => {
    const colors = {
      programming: '#2196F3',
      tools: '#4CAF50', 
      hardware: '#FF9800',
      other: '#9C27B0'
    };
    return colors[category] || '#757575';
  };

  // Rating handlers
  const handleRatingChange = async (id, newValue) => {
    setRatings(prevRatings => ({ ...prevRatings, [id]: newValue }));
    try {
      await updateRatingLogbook(id, newValue);
      dispatch(updateSnackbar({
        isOpen: true,
        message: "อัปเดตคะแนนสำเร็จ",
        severity: "success"
      }));
    } catch (error) {
      dispatch(updateSnackbar({
        isOpen: true,
        message: "เกิดข้อผิดพลาดในการอัปเดตคะแนน",
        severity: "error"
      }));
    }
  };

  const handleRatingChange2 = async (id, newValue) => {
    setRatings(prevRatings => ({ ...prevRatings, [id]: newValue }));
    try {
      await updateRatingInternManual(id, newValue);
      dispatch(updateSnackbar({
        isOpen: true,
        message: "อัปเดตคะแนนสำเร็จ",
        severity: "success"
      }));
    } catch (error) {
      dispatch(updateSnackbar({
        isOpen: true,
        message: "เกิดข้อผิดพลาดในการอัปเดตคะแนน",
        severity: "error"
      }));
    }
  };

  // Copy all logbook links as JSON array
  const copyAllLogbookLinks = () => {
    if (logbookDetail && logbookDetail.length > 0) {
      const links = logbookDetail.map(logbook => logbook.link).filter(link => link);
      const jsonArray = JSON.stringify(links);
      
      navigator.clipboard.writeText(jsonArray).then(() => {
        setCopiedLogbooks(true);
        dispatch(updateSnackbar({
          isOpen: true,
          message: `คัดลอกลิงก์ logbook ทั้งหมด ${links.length} รายการสำเร็จ`,
          severity: "success"
        }));
        
        // Reset copied state after 3 seconds
        setTimeout(() => setCopiedLogbooks(false), 3000);
      }).catch(() => {
        dispatch(updateSnackbar({
          isOpen: true,
          message: "เกิดข้อผิดพลาดในการคัดลอก",
          severity: "error"
        }));
      });
    }
  };

  const handleRatingChange3 = async (id, req_id, newValue) => {
    setRatings(prevRatings => ({ ...prevRatings, [id]: newValue }));
    try {
      await updateRatingProposal(req_id, newValue);
      dispatch(updateSnackbar({
        isOpen: true,
        message: "อัปเดตคะแนนสำเร็จ",
        severity: "success"
      }));
    } catch (error) {
      dispatch(updateSnackbar({
        isOpen: true,
        message: "เกิดข้อผิดพลาดในการอัปเดตคะแนน",
        severity: "error"
      }));
    }
  };

  // ฟังก์ชันง่ายๆ ในการดึงข้อมูล
  const fetchData = async () => {
    try {
      setIsLoading(true);
      
      if (!internRequestId) {
        dispatch(updateSnackbar({
          isOpen: true,
          message: "ไม่พบรหัสคำขอฝึกงาน กรุณาระบุ req_id ใน URL",
          severity: "warning"
        }));
        return;
      }

      // ดึงข้อมูลตาม req_id
      const studentData = await getInternshipRequestById(internRequestId);
      
      if (studentData && studentData.length > 0) {
        
        // ดึงข้อมูลอาจารย์นิเทศ
        const allStaff = await engApi.get("/all-staff/");
        const supervisor = allStaff.data?.find(
          (el) => el?.id === studentData[0]?.supervisor
        );
        
        // ดึงข้อมูลพี่เลี้ยง (auditor)
        const auditorData = allStaff.data?.find(
          (el) => el?.id === studentData[0]?.auditor
        );
        setAuditor(auditorData);
        
        // ดึงข้อมูลเพิ่มเติม
        const logbooks = await getLogbookById(studentData[0].st_id);
        const internReport = await getInternReportById(studentData[0].st_id);
        const proposal = await getProposalById(studentData[0].st_id);
        const coopReport = await getCoopReportById(studentData[0].st_id);
        const internManual = await getInternManualById(internRequestId);
        
        // Filter internManual by req_id (same as InternStdDetail.js)
        const filteredInternManual = internManual?.filter((el) => {
          return el?.intern_request_id == internRequestId;
        });
        
        // ดึงคะแนนจากบริษัท
        const totalScore = await getTotalScoreOnly(internRequestId);
        
        // Fetch intern assessment scores
        let internVisitScore = 0, internVisitMax = 60;
        let internReportScore = 0, internReportMax = 40;
        
        try {
          const visitInternAll = await getAssessment();
          const visitInternRecords = (visitInternAll || []).filter((el) => el.req_id == internRequestId);
          if (visitInternRecords.length > 0) {
            // Use only the latest record (not sum all records)
            const latestRecord = visitInternRecords[visitInternRecords.length - 1];
            for (let i = 1; i <= 12; i++) {
              const listKey = `list_${i}`;
              if (latestRecord[listKey]) {
                internVisitScore += parseInt(latestRecord[listKey]) || 0;
              }
            }
            internVisitMax = latestRecord.max_score || 60;
          }
        } catch (e) {
          // Assessment fetch failed
        }
        
        try {
          const reportInternAll = await getAssessment_report();
          const reportInternRecords = (reportInternAll || []).filter((el) => el.req_id == internRequestId);
          if (reportInternRecords.length > 0) {
            // Use only the latest record (not sum all records)
            const latestRecord = reportInternRecords[reportInternRecords.length - 1];
            for (let i = 1; i <= 8; i++) {
              const listKey = `list_${i}`;
              if (latestRecord[listKey]) {
                internReportScore += parseInt(latestRecord[listKey]) || 0;
              }
            }
            internReportMax = latestRecord.max_score || 40;
          }
        } catch (e) {
          // Assessment report fetch failed
        }
        
        // Fetch coop assessment scores
        let coopVisitScore = 0, coopVisitMax = 120;
        let coopPresentScore = 0, coopPresentMax = 50;
        let coopCompanyScore = 0, coopCompanyMax = 200;
        let coopReportScore = 0, coopReportMax = 100;
        
        try {
          const visitCoopAll = await getAssessmentCoop();
          const visitCoopRecords = (visitCoopAll || []).filter((el) => el.req_id == internRequestId);
          if (visitCoopRecords.length > 0) {
            // Use only the latest record and list_1 to list_24 only
            const latestRecord = visitCoopRecords[visitCoopRecords.length - 1];
            for (let i = 1; i <= 24; i++) {
              const listKey = `list_${i}`;
              if (latestRecord[listKey]) {
                coopVisitScore += parseInt(latestRecord[listKey]) || 0;
              }
            }
            coopVisitMax = latestRecord.max_score || 120;
          }
        } catch (e) {
          // Coop assessment fetch failed
        }
        
        try {
          const presentCoopAll = await getAssessment_presentcoop();
          const presentCoopRecords = (presentCoopAll || []).filter((el) => el.req_id == internRequestId);
          if (presentCoopRecords.length > 0) {
            // Use only the latest record (not sum all records)
            const latestRecord = presentCoopRecords[presentCoopRecords.length - 1];
            for (let i = 1; i <= 10; i++) {
              const listKey = `list_${i}`;
              if (latestRecord[listKey]) {
                coopPresentScore += parseInt(latestRecord[listKey]) || 0;
              }
            }
            coopPresentMax = latestRecord.max_score || 50;
          }
        } catch (e) {
          // Present coop assessment fetch failed
        }
        
        try {
          const companyCoopAll = await getAssessment_companycoop();
          const companyCoop = (companyCoopAll || []).find((el) => el.req_id == internRequestId);
          if (companyCoop) {
            coopCompanyScore = companyCoop.total_score || companyCoop.totalScore || 0;
            coopCompanyMax = companyCoop.max_score || 200;
          }
        } catch (e) {
          // Company coop assessment fetch failed
        }
        
        try {
          const reportCoopAll = await getAssessment_reportcoop();
          const reportCoop = (reportCoopAll || []).find((el) => el.req_id == internRequestId);
          if (reportCoop) {
            coopReportScore = reportCoop.total_score || 0;
            coopReportMax = reportCoop.max_score || 100;
          }
        } catch (e) {
          // Report coop assessment fetch failed
        }
        
        // ดึงข้อมูลหัวข้อโครงงานสหกิจ
        try {
          const coopReportDetailData = await getCoopReportDetail(internRequestId);
          if (coopReportDetailData?.success && coopReportDetailData?.header?.project_title) {
            setCoopReportProjectTitle(coopReportDetailData.header.project_title);
          }
        } catch (e) {
          // Coop report detail fetch failed
        }
        
        // เซ็ตข้อมูลทั้งหมด
        const profileData = {
          ...studentData[0],
          supervisorName: supervisor?.name,
          internVisitScore,
          internVisitMax,
          internReportScore,
          internReportMax,
          coopVisitScore,
          coopVisitMax,
          coopPresentScore,
          coopPresentMax,
          coopCompanyScore,
          coopCompanyMax,
          coopReportScore,
          coopReportMax
        };
        
        setProfileDetail(profileData);
        setLogbookDetail(logbooks || []);
        setInternReportDetail(internReport || []);
        setProposalDetail(proposal || []);
        setCoopReportDetail(coopReport || []);
        setInternManualDetail(filteredInternManual || []);
        
        const companyScore = totalScore?.total_score || totalScore?.totalScore || null;
        setTotalScoreCompany(companyScore);
      } else {
        dispatch(updateSnackbar({
          isOpen: true,
          message: `ไม่พบข้อมูลการฝึกงานสำหรับ req_id: ${internRequestId}`,
          severity: "error"
        }));
      }

    } catch (error) {
      dispatch(updateSnackbar({
        isOpen: true,
        message: "เกิดข้อผิดพลาดในการโหลดข้อมูล",
        severity: "error"
      }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [internRequestId]);

  // Loading state
  if (isLoading) {
    return (
      <Container>
        <Box 
          display="flex" 
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>กำลังโหลดข้อมูล...</Typography>
        </Box>
      </Container>
    );
  }

  // No data state
  if (!profileDetail) {
    return (
      <Container>
        <Box 
          display="flex" 
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <Typography variant="h6" color="text.secondary">
            ไม่พบข้อมูลการฝึกงาน
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            กรุณาตรวจสอบ req_id ใน URL
          </Typography>
        </Box>
      </Container>
    );
  }

  // Main content
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant={isMobile ? "h5" : "h4"} component="h1" sx={{ fontWeight: 'bold' }}>
            ประเมินผลนิสิตรายบุคคล
          </Typography>
          <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
            RequestID: {profileDetail?.req_id}
          </Typography>
        </Box>

        {/* Main Content */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            {/* Student Photo and Basic Info */}
            <Paper elevation={2} sx={{ p: 2, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ mb: 1.5 }}>
                {profileDetail && !isNaN(profileDetail.st_id) ? (
                  <img
                    src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${profileDetail?.st_id}`}
                    width="130px"
                    style={{ 
                      borderRadius: '8px'
                    }}
                    alt="Student"
                  />
                ) : (
                  <img 
                    src={`./assets/images/user.png`} 
                    width="130px" 
                    style={{ 
                      borderRadius: '8px'
                    }}
                    alt="Default User"
                  />
                )}
              </Box>

              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                {profileDetail?.st_name}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {profileDetail?.st_id}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={8}>
            {/* Student Details */}
            <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', py: 0.75, borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    สาขาวิชา
                  </Typography>
                  <Typography variant="body2">
                    {optionsBranch?.find((el) => el.value == profileDetail?.b_id)?.label}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', py: 0.75, borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    เกรดเฉลี่ยสะสม
                  </Typography>
                  <Chip 
                    label={(+profileDetail?.GPA)?.toFixed(2)} 
                    color="primary" 
                    size="small"
                    sx={{ fontWeight: 600, height: '22px' }}
                  />
                </Box>

                <Box sx={{ display: 'flex', py: 0.75, borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    Email
                  </Typography>
                  <Typography variant="body2">
                    <a href={`mailto:${profileDetail?.st_mail}`} style={{ color: '#1976d2', textDecoration: 'none' }}>
                      {profileDetail?.st_mail}
                    </a>
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', py: 0.75, borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    เบอร์โทร
                  </Typography>
                  <Typography variant="body2">
                    <a href={`tel:${profileDetail?.st_tel || profileDetail?.tel}`} style={{ color: '#1976d2', textDecoration: 'none' }}>
                      {profileDetail?.st_tel || profileDetail?.tel || '-'}
                    </a>
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', py: 0.75, borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    สถานะ
                  </Typography>
                  {!!profileDetail && generateStatus(profileDetail?.status_id)}
                </Box>

                <Box sx={{ display: 'flex', py: 0.75, borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    สถานประกอบการ
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Chip 
                      label={`ID : ${profileDetail?.cp_id || profileDetail?.company_id || 'N/A'}`}
                      color="primary"
                      size="small"
                      sx={{ fontWeight: 600, height: '22px' }}
                    />
                    <Typography variant="body2">
                      {profileDetail?.cp_name || profileDetail?.company_name || '-'}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', py: 0.75 }}>
                  <Typography variant="body2" sx={{ minWidth: '180px', fontWeight: 600, color: 'text.secondary' }}>
                    อาจารย์นิเทศ
                  </Typography>
                  <Typography variant="body2">
                    {profileDetail?.supervisorName}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* Additional Cards Section */}
        <Grid container spacing={3} sx={{ mt: 2 }}>
          {/* บันทึกการฝึกงาน Card */}
          {logbookDetail && logbookDetail.length > 0 && (
            <Grid item xs={12}>
              <Paper elevation={1} sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6" color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Assignment /> บันทึกการฝึกงาน
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<ContentCopy />}
                      onClick={copyAllLogbookLinks}
                      sx={{ 
                        bgcolor: copiedLogbooks ? 'success.light' : 'transparent',
                        color: copiedLogbooks ? 'success.contrastText' : 'primary.main'
                      }}
                    >
                      {copiedLogbooks ? 'คัดลอกแล้ว!' : `คัดลอกลิงก์ทั้งหมด (${logbookDetail.length})`}
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<Psychology />}
                      onClick={analyzeWithAI}
                      disabled={isAnalyzing || logbookDetail.length === 0}
                      sx={{ bgcolor: 'secondary.main' }}
                    >
                      {isAnalyzing ? 'กำลังวิเคราะห์...' : 'วิเคราะห์ด้วย AI'}
                    </Button>
                  </Box>
                </Box>
                <Grid container spacing={2}>
                  {logbookDetail.map((logbook, index) => (
                    <Grid item xs={12} sm={6} md={3} key={logbook.id}>
                      <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
                        <Box sx={{ 
                          border: '1px solid #e0e0e0', 
                          borderRadius: 1, 
                          bgcolor: '#f5f5f5', 
                          p: 2, 
                          mb: 2 
                        }}>
                          <a href={logbook?.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                            <PictureAsPdf sx={{ fontSize: 40, mb: 1, cursor: 'pointer', color: '#ef5350' }} />
                            <Typography variant="body2" sx={{ mb: 1, color: 'primary.main', fontWeight: 500 }}>Logbook#{logbook.no}</Typography>
                          </a>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center' }}>
                            {logbook?.date_created && (
                              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Chip 
                                  label="created:"
                                  size="small"
                                  sx={{ 
                                    fontSize: '0.7rem',
                                    height: '20px',
                                    bgcolor: '#e0e0e0',
                                    color: '#333'
                                  }}
                                />
                                <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                  {logbook.date_created}
                                </Typography>
                              </Box>
                            )}
                            {logbook?.date_updated && (
                              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Chip 
                                  label="updated:"
                                  size="small"
                                  sx={{ 
                                    fontSize: '0.7rem',
                                    height: '20px',
                                    bgcolor: '#e0e0e0',
                                    color: '#333'
                                  }}
                                />
                                <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                  {logbook.date_updated}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
                        <Rating 
                          value={ratings[logbook.id] || logbook.mark || 0} 
                          size="small" 
                          onChange={(event, newValue) => handleRatingChange(logbook.id, newValue)}
                          sx={{ mb: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center' }}>
                          {logbook?.markby && (
                            <Typography variant="caption" sx={{ fontSize: '0.75rem', color: '#666' }}>
                              by: {logbook.markby}
                            </Typography>
                          )}
                          {logbook?.markedDate && (
                            <Chip 
                              label={logbook.markedDate}
                              size="small"
                              sx={{ 
                                fontSize: '0.7rem',
                                height: '20px',
                                bgcolor: '#2196F3',
                                color: 'white'
                              }}
                            />
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          )}

          {/* แบบฟอร์มแจ้งที่ตั้งสถานประกอบการ Card */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn /> แบบฟอร์มแจ้งที่ตั้งสถานประกอบการ
              </Typography>
              <Stack spacing={2}>
                {internManualDetail && internManualDetail.length > 0 ? (
                  internManualDetail.map((manual) => {
                    // Parse manual_data to get Google Map link
                    let manualData = null;
                    let googleMapLink = null;
                    let embedMapUrl = null;
                    let latitude = null;
                    let longitude = null;
                    
                    try {
                      if (manual.manual_data) {
                        manualData = JSON.parse(manual.manual_data);
                        googleMapLink = manualData?.location?.link;
                        latitude = manualData?.location?.lat;
                        longitude = manualData?.location?.lng;
                        
                        // Use latitude and longitude from location object first
                        if (latitude && longitude) {
                          embedMapUrl = `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
                        } else if (googleMapLink) {
                          // Try to extract coordinates from the link if lat/lng not available
                          const coordMatch = googleMapLink.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
                          if (coordMatch) {
                            const lat = coordMatch[1];
                            const lng = coordMatch[2];
                            embedMapUrl = `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
                          }
                        }
                      }
                    } catch (e) {
                      // Error parsing manual data
                    }

                    return (
                      <Box key={manual.id}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                          <Rating 
                            value={ratings[manual.intern_request_id] || manual.mark || 0} 
                            size="small" 
                            onChange={(event, newValue) => handleRatingChange2(manual.intern_request_id, newValue)}
                          />
                          <Link 
                            to={`/intern-manual?req_id=${profileDetail?.req_id}`}
                            target="_blank"
                            style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}
                          >
                            <OpenInNew sx={{ fontSize: 20, color: 'primary.main' }} />
                            <Typography variant="body2" sx={{ color: 'primary.main' }}>ดูแบบฟอร์ม</Typography>
                          </Link>
                          {googleMapLink && (
                            <a 
                              href={googleMapLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                              <LocationOn sx={{ fontSize: 20, color: '#4285F4' }} />
                              <Typography variant="body2" sx={{ color: '#4285F4' }}>Google Map</Typography>
                            </a>
                          )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 1 }}>
                          {manual?.date_created && (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip 
                                label="created:"
                                size="small"
                                sx={{ 
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  bgcolor: '#e0e0e0',
                                  color: '#333'
                                }}
                              />
                              <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                {manual.date_created}
                              </Typography>
                            </Box>
                          )}
                          {manual?.date_updated && (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip 
                                label="updated:"
                                size="small"
                                sx={{ 
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  bgcolor: '#e0e0e0',
                                  color: '#333'
                                }}
                              />
                              <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                {manual.date_updated}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        {embedMapUrl && (
                          <Box sx={{ 
                            width: '100%', 
                            height: '250px', 
                            borderRadius: 1, 
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0',
                            mt: 1
                          }}>
                            <iframe
                              src={embedMapUrl}
                              width="100%"
                              height="100%"
                              style={{ border: 0 }}
                              allowFullScreen=""
                              loading="lazy"
                              referrerPolicy="no-referrer-when-downgrade"
                              title="Google Maps Location"
                            />
                          </Box>
                        )}
                        {!embedMapUrl && (latitude || longitude || googleMapLink) && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}>
                            ไม่สามารถแสดง Mini Map Preview ได้ (ข้อมูลพิกัดไม่ครบถ้วน)
                          </Typography>
                        )}
                      </Box>
                    );
                  })
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    ยังไม่มีข้อมูลแบบฟอร์มแจ้งที่ตั้งสถานประกอบการ
                  </Typography>
                )}
              </Stack>
            </Paper>
          </Grid>

          {/* ข้อมูลพี่เลี้ยง Card */}
          {internManualDetail && internManualDetail.length > 0 && internManualDetail.map((manual) => {
            let auditorData = null;
            try {
              if (manual.manual_data) {
                const manualData = JSON.parse(manual.manual_data);
                auditorData = manualData?.auditor;
              }
            } catch (e) {
              // Error parsing auditor data
            }

            if (auditorData) {
              return (
                <Grid item xs={12} md={6} key={`auditor-${manual.id}`}>
                  <Paper elevation={1} sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonPin /> ข้อมูลพี่เลี้ยง
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      {auditorData.name && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" sx={{ minWidth: '100px', fontWeight: 'bold', color: 'text.secondary' }}>
                            ชื่อ-นามสกุล:
                          </Typography>
                          <Typography variant="body2">
                            {auditorData.name}
                          </Typography>
                        </Box>
                      )}
                      {auditorData.position && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" sx={{ minWidth: '100px', fontWeight: 'bold', color: 'text.secondary' }}>
                            ตำแหน่ง:
                          </Typography>
                          <Typography variant="body2">
                            {auditorData.position}
                          </Typography>
                        </Box>
                      )}
                      {auditorData.department && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" sx={{ minWidth: '100px', fontWeight: 'bold', color: 'text.secondary' }}>
                            แผนก/ฝ่าย:
                          </Typography>
                          <Typography variant="body2">
                            {auditorData.department}
                          </Typography>
                        </Box>
                      )}
                      {auditorData.tel && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" sx={{ minWidth: '100px', fontWeight: 'bold', color: 'text.secondary' }}>
                            โทรศัพท์:
                          </Typography>
                          <Typography variant="body2">
                            <a href={`tel:${auditorData.tel}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                              {auditorData.tel}
                            </a>
                          </Typography>
                        </Box>
                      )}
                      {auditorData.fax && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" sx={{ minWidth: '100px', fontWeight: 'bold', color: 'text.secondary' }}>
                            Email:
                          </Typography>
                          <Typography variant="body2">
                            <a href={`mailto:${auditorData.fax}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                              {auditorData.fax}
                            </a>
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </Grid>
              );
            }
            return null;
          })}

          {/* งานที่ได้รับมอบหมาย Card */}
          {internManualDetail && internManualDetail.length > 0 && internManualDetail.map((manual) => {
            let jobData = null;
            try {
              if (manual.manual_data) {
                const manualData = JSON.parse(manual.manual_data);
                jobData = manualData?.job;
              }
            } catch (e) {
              // Error parsing job data
            }

            if (jobData && (jobData.position || jobData.desc)) {
              return (
                <Grid item xs={12} md={6} key={`job-${manual.id}`}>
                  <Paper elevation={1} sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Assignment /> งานที่ได้รับมอบหมายให้นิสิตปฏิบัติ
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {jobData.position && (
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'text.secondary', mb: 0.5 }}>
                            ตำแหน่งงานที่นิสิตปฏิบัติ (Job Position):
                          </Typography>
                          <Typography variant="body2" sx={{ pl: 2 }}>
                            {jobData.position}
                          </Typography>
                        </Box>
                      )}
                      {jobData.desc && (
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'text.secondary', mb: 0.5 }}>
                            ลักษณะงานและความรับผิดชอบที่นิสิตปฏิบัติ (Job Description):
                          </Typography>
                          <Typography variant="body2" sx={{ pl: 2, lineHeight: 1.6 }}>
                            {jobData.desc}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </Grid>
              );
            }
            return null;
          })}

          {/* ฝึกงาน 2 เดือน Card */}
          {profileDetail?.type_internship != 2 && (
            <Grid item xs={12} md={6}>
              <Paper elevation={1} sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Assignment /> ฝึกงาน 2 เดือน
                </Typography>
                <Stack spacing={2}>
                  {internReportDetail.map((report) => (
                    <Box key={report.id}>
                      <a href={report?.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        <Typography variant="body2" sx={{ mb: 1, color: 'primary.main' }}>รายงานฝึกงาน 2 เดือน</Typography>
                      </a>
                      <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap' }}>
                        {report?.date_created && (
                          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                            <Chip 
                              label="created:"
                              size="small"
                              sx={{ 
                                fontSize: '0.7rem',
                                height: '20px',
                                bgcolor: '#e0e0e0',
                                color: '#333'
                              }}
                            />
                            <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                              {report.date_created}
                            </Typography>
                          </Box>
                        )}
                        {report?.date_updated && (
                          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                            <Chip 
                              label="updated:"
                              size="small"
                              sx={{ 
                                fontSize: '0.7rem',
                                height: '20px',
                                bgcolor: '#e0e0e0',
                                color: '#333'
                              }}
                            />
                            <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                              {report.date_updated}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  ))}
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {profileDetail?.internVisitScore > 0 ? (
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                          <Typography variant="body2">ผลประเมินการนิเทศนิสิตฝึกงาน 2 เดือน</Typography>
                          <Chip 
                            label={`${profileDetail.internVisitScore} / ${profileDetail.internVisitMax}`}
                            color="primary"
                            size="small"
                          />
                        </Box>
                        <Link to={`/assessment-visit?req_id=${profileDetail?.req_id}`} target="_blank">
                          <OpenInNew sx={{ fontSize: 16 }} />
                        </Link>
                      </Box>
                    ) : (
                      <Link to={`/assessment-visit?req_id=${profileDetail?.req_id}`} target="_blank" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <FactCheck color="secondary" />
                        <Typography variant="body2" sx={{ color: 'secondary.main' }}>ส่งผลประเมินการนิเทศนิสิตฝึกงาน 2 เดือน</Typography>
                      </Link>
                    )}
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {profileDetail?.internReportScore > 0 ? (
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                          <Typography variant="body2">ผลประเมินรายงานและการนำเสนอฝึกงาน 2 เดือน</Typography>
                          <Chip 
                            label={`${profileDetail.internReportScore} / ${profileDetail.internReportMax}`}
                            color="default"
                            size="small"
                          />
                        </Box>
                        <Link to={`/assessment-report?req_id=${profileDetail?.req_id}`} target="_blank">
                          <OpenInNew sx={{ fontSize: 16 }} />
                        </Link>
                      </Box>
                    ) : (
                      <Link to={`/assessment-report?req_id=${profileDetail?.req_id}`} target="_blank" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <FactCheck color="success" />
                        <Typography variant="body2" sx={{ color: 'success.main' }}>ส่งผลประเมินรายงานและการนำเสนอฝึกงาน 2 เดือน</Typography>
                      </Link>
                    )}
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {totalScoreCompany ? (
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                          <Typography variant="body2">ผลประเมินจากสถานประกอบการ</Typography>
                          <Chip 
                            label={`${parseFloat(totalScoreCompany) % 1 === 0 ? parseInt(totalScoreCompany) : totalScoreCompany} / 85`}
                            color="success"
                            size="small"
                          />
                          <Tooltip title="ส่งอีเมลให้พี่เลี้ยง">
                            <a 
                              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}&su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการฝึกงาน 2 เดือน - นิสิตฝึกงาน ' + profileDetail?.st_name)}&body=${encodeURIComponent(bodymail)}`}
                              target="_blank"
                              rel="noreferrer"
                              style={{ color: 'inherit', display: 'flex', alignItems: 'center' }}
                            >
                              <Email sx={{ fontSize: 20 }} />
                            </a>
                          </Tooltip>
                        </Box>
                        <Link to={`/internship-evaluation?req_id=${profileDetail?.req_id}`} target="_blank">
                          <OpenInNew sx={{ fontSize: 16 }} />
                        </Link>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Tooltip title="ส่งอีเมลให้พี่เลี้ยง">
                          <a 
                            href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}&su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการฝึกงาน 2 เดือน - นิสิตฝึกงาน ' + profileDetail?.st_name)}&body=${encodeURIComponent(bodymail)}`}
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: 'inherit', display: 'flex', alignItems: 'center' }}
                          >
                            <Email color="primary" sx={{ cursor: 'pointer' }} />
                          </a>
                        </Tooltip>
                        <Typography variant="body2">ส่ง e-mail ให้พี่เลี้ยงเพื่อประเมินผลฝึกงาน 2 เดือน</Typography>
                      </Box>
                    )}
                  </Box>
                </Stack>
              </Paper>
            </Grid>
          )}

          {/* สหกิจศึกษา Card */}
          {profileDetail?.type_internship !== 1 && (
            <Grid item xs={12}>
              <Paper elevation={1} sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Assignment /> สหกิจศึกษา
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    {proposalDetail.length === 0 && coopReportDetail.length === 0 ? (
                      <Box sx={{ 
                        p: 3, 
                        textAlign: 'center', 
                        bgcolor: '#f5f5f5', 
                        borderRadius: 1,
                        border: '1px dashed #ccc'
                      }}>
                        <Typography variant="body2" color="text.secondary">
                          ยังไม่ได้ส่งรายละเอียดโครงงานและรายงานสหกิจศึกษา
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        {proposalDetail.map((proposal) => (
                          <Box key={proposal.id} sx={{ mb: 2 }}>
                            <a href={proposal?.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                              <Typography variant="body2" sx={{ mb: 1, color: 'primary.main' }}>รายละเอียดโครงงานสหกิจศึกษาฯ</Typography>
                            </a>
                            <Box sx={{ display: 'flex', gap: 2, mb: 1, flexWrap: 'wrap' }}>
                          {proposal?.date_created && (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip 
                                label="created:"
                                size="small"
                                sx={{ 
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  bgcolor: '#e0e0e0',
                                  color: '#333'
                                }}
                              />
                              <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                {proposal.date_created}
                              </Typography>
                            </Box>
                          )}
                          {proposal?.date_updated && (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip 
                                label="updated:"
                                size="small"
                                sx={{ 
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  bgcolor: '#e0e0e0',
                                  color: '#333'
                                }}
                              />
                              <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                {proposal.date_updated}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        <Rating 
                          value={ratings[proposal.id] || proposal.mark || 0} 
                          size="small" 
                          onChange={(event, newValue) => handleRatingChange3(proposal.id, proposal.req_id, newValue)}
                        />
                      </Box>
                    ))}
                    {coopReportDetail.map((report) => (
                      <Box key={report.id} sx={{ mb: 2 }}>
                        {coopReportProjectTitle && (
                          <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: 'text.primary' }}>
                            หัวข้อโครงงานสหกิจ: {coopReportProjectTitle}
                          </Typography>
                        )}
                        <a href={report?.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                          <Typography variant="body2" sx={{ mb: 1, color: 'primary.main' }}>รายงานสหกิจศึกษา</Typography>
                        </a>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                          {report?.date_created && (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip 
                                label="created:"
                                size="small"
                                sx={{ 
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  bgcolor: '#e0e0e0',
                                  color: '#333'
                                }}
                              />
                              <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                {report.date_created}
                              </Typography>
                            </Box>
                          )}
                          {report?.date_updated && (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip 
                                label="updated:"
                                size="small"
                                sx={{ 
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  bgcolor: '#e0e0e0',
                                  color: '#333'
                                }}
                              />
                              <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                {report.date_updated}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    ))}
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {profileDetail?.coopVisitScore > 0 ? (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                              <Typography variant="body2">ผลประเมินการนิเทศนิสิตสหกิจศึกษา</Typography>
                              <Chip 
                                label={`${profileDetail.coopVisitScore} / ${profileDetail.coopVisitMax}`}
                                color="primary"
                                size="small"
                              />
                            </Box>
                            <Link to={`/assessment-visitcoop?req_id=${profileDetail?.req_id}`} target="_blank">
                              <OpenInNew sx={{ fontSize: 16 }} />
                            </Link>
                          </Box>
                        ) : (
                          <Link to={`/assessment-visitcoop?req_id=${profileDetail?.req_id}`} target="_blank" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>
                            <FactCheck color="secondary" />
                            <Typography variant="body2" sx={{ color: 'secondary.main' }}>ส่งผลประเมินการนิเทศนิสิตสหกิจศึกษา</Typography>
                          </Link>
                        )}
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {profileDetail?.coopPresentScore > 0 ? (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                              <Typography variant="body2">ผลประเมินการนำเสนอสหกิจศึกษา</Typography>
                              <Chip 
                                label={`${profileDetail.coopPresentScore} / ${profileDetail.coopPresentMax}`}
                                color="default"
                                size="small"
                              />
                            </Box>
                            <Link to={`/assessment-presentcoop?req_id=${profileDetail?.req_id}`} target="_blank">
                              <OpenInNew sx={{ fontSize: 16 }} />
                            </Link>
                          </Box>
                        ) : (
                          <Link to={`/assessment-presentcoop?req_id=${profileDetail?.req_id}`} target="_blank" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>
                            <FactCheck color="success" />
                            <Typography variant="body2" sx={{ color: 'success.main' }}>ส่งผลประเมินการนำเสนอสหกิจศึกษา</Typography>
                          </Link>
                        )}
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {profileDetail?.coopCompanyScore > 0 ? (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                              <Typography variant="body2">ผลประเมินจากสถานประกอบการ</Typography>
                              <Chip 
                                label={`${profileDetail.coopCompanyScore} / ${profileDetail.coopCompanyMax}`}
                                color="success"
                                size="small"
                              />
                              <Tooltip title="ส่งอีเมลให้พี่เลี้ยง">
                                <a
                                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}&su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา - นิสิตฝึกงาน ' + profileDetail?.st_name)}&body=${encodeURIComponent(bodymailcoop)}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{ color: 'inherit', display: 'flex', alignItems: 'center' }}
                                >
                                  <Email sx={{ fontSize: 20 }} />
                                </a>
                              </Tooltip>
                            </Box>
                            <Link to={`/supervisor-evaluation?req_id=${profileDetail?.req_id}`} target="_blank">
                              <OpenInNew sx={{ fontSize: 16 }} />
                            </Link>
                          </Box>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Tooltip title="ส่งอีเมลให้พี่เลี้ยง">
                              <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}&su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา - นิสิตฝึกงาน ' + profileDetail?.st_name)}&body=${encodeURIComponent(bodymailcoop)}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: 'inherit', display: 'flex', alignItems: 'center' }}
                              >
                                <Email 
                                  color="success" 
                                  sx={{ cursor: 'pointer' }} 
                                />
                              </a>
                            </Tooltip>
                            <Typography variant="body2">ส่ง e-mail ให้พี่เลี้ยงเพื่อประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา</Typography>
                          </Box>
                        )}
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {profileDetail?.coopReportScore > 0 ? (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                              <Typography variant="body2">ผลประเมินรายงานสหกิจศึกษา</Typography>
                              <Chip 
                                label={`${parseFloat(profileDetail.coopReportScore) % 1 === 0 ? parseInt(profileDetail.coopReportScore) : profileDetail.coopReportScore} / ${parseFloat(profileDetail.coopReportMax) % 1 === 0 ? parseInt(profileDetail.coopReportMax) : profileDetail.coopReportMax}`}
                                sx={{ bgcolor: '#212529', color: 'white' }}
                                size="small"
                              />
                            </Box>
                            <Link to={`/coop-report-evaluation?req_id=${profileDetail?.req_id}`} target="_blank">
                              <OpenInNew sx={{ fontSize: 16 }} />
                            </Link>
                          </Box>
                        ) : null}
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* AI Analysis Results Dialog */}
      <Dialog 
        open={showAnalysisDialog} 
        onClose={() => setShowAnalysisDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { maxHeight: '90vh' }
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Psychology color="secondary" />
            <Typography variant="h6">📊 ผลการวิเคราะห์ด้วย AI</Typography>
          </Box>
          <IconButton onClick={() => setShowAnalysisDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        
        <DialogContent dividers>
          {analysisResults && (
            <Grid container spacing={3}>
              {/* Student Info Summary */}
              <Grid item xs={12}>
                <Paper elevation={1} sx={{ p: 2, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                  <Typography variant="h6" gutterBottom>👨‍🎓 ข้อมูลนิสิต</Typography>
                  <Typography><strong>ชื่อ:</strong> {analysisResults.student_name}</Typography>
                  <Typography><strong>รหัสนิสิต:</strong> {analysisResults.student_id}</Typography>
                  <Typography><strong>บริษัท:</strong> {analysisResults.internship?.company}</Typography>
                  <Typography><strong>ตำแหน่ง:</strong> {analysisResults.internship?.role}</Typography>
                </Paper>
              </Grid>

              {/* Tech Stack */}
              <Grid item xs={12} md={6}>
                <Paper elevation={1} sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom color="primary">🛠️ เทคโนโลยีที่ใช้</Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {analysisResults.tech_stack?.map((tech, index) => (
                      <Chip 
                        key={index} 
                        label={tech} 
                        size="small" 
                        color="primary" 
                        variant="outlined"
                      />
                    ))}
                  </Box>
                </Paper>
              </Grid>

              {/* Skills Analysis */}
              <Grid item xs={12} md={6}>
                <Paper elevation={1} sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom color="primary">💡 ทักษะที่ได้รับการพัฒนา</Typography>
                  <Stack spacing={1}>
                    {analysisResults.skills?.slice(0, 6).map((skill, index) => (
                      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip 
                          label={skill.category}
                          size="small" 
                          sx={{ 
                            bgcolor: getSkillCategoryColor(skill.category),
                            color: 'white',
                            minWidth: 80
                          }}
                        />
                        <Typography variant="body2">{skill.name}</Typography>
                      </Box>
                    ))}
                    {analysisResults.skills?.length > 6 && (
                      <Typography variant="caption" color="text.secondary">
                        และอีก {analysisResults.skills.length - 6} ทักษะ
                      </Typography>
                    )}
                  </Stack>
                </Paper>
              </Grid>

              {/* Tasks Summary */}
              <Grid item xs={12}>
                <Paper elevation={1} sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom color="primary">📋 สรุปกิจกรรมการฝึกงาน</Typography>
                  <Stack spacing={2}>
                    {analysisResults.tasks?.slice(0, 5).map((task, index) => (
                      <Box key={index}>
                        <Typography variant="body2" sx={{ bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
                          <strong>สัปดาห์ที่ {index + 1}:</strong> {task.summary}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>
                </Paper>
              </Grid>

              {/* Soft Skills */}
              <Grid item xs={12} md={6}>
                <Paper elevation={1} sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom color="primary">🤝 Soft Skills</Typography>
                  <Stack spacing={1}>
                    {analysisResults.soft_skills?.map((skill, index) => (
                      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CheckCircle color="success" sx={{ fontSize: 16 }} />
                        <Typography variant="body2">{skill.name}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Paper>
              </Grid>

              {/* Outcomes */}
              <Grid item xs={12} md={6}>
                <Paper elevation={1} sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom color="primary">🎯 ผลงานที่ได้</Typography>
                  <Stack spacing={1}>
                    {analysisResults.outcomes?.map((outcome, index) => (
                      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip label={outcome.type} size="small" color="secondary" />
                        <Typography variant="body2">{outcome.detail}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Paper>
              </Grid>

              {/* Notes */}
              {analysisResults.notes && (
                <Grid item xs={12}>
                  <Paper elevation={1} sx={{ p: 2, bgcolor: 'warning.light' }}>
                    <Typography variant="h6" gutterBottom>📝 สรุปและข้อสังเกต</Typography>
                    <Typography variant="body2">{analysisResults.notes}</Typography>
                  </Paper>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        
        <DialogActions>
          <Button onClick={() => setShowAnalysisDialog(false)} color="primary">
            ปิด
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loading overlay during analysis */}
      {isAnalyzing && (
        <Dialog open={isAnalyzing} maxWidth="sm" fullWidth>
          <DialogContent sx={{ textAlign: 'center', py: 4 }}>
            <Psychology sx={{ fontSize: 64, color: 'secondary.main', mb: 2 }} />
            <Typography variant="h6" gutterBottom>กำลังวิเคราะห์ด้วย AI</Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              กำลังประมวลผล logbook ทั้งหมด {logbookDetail.length} ไฟล์...
            </Typography>
            <LinearProgress sx={{ mt: 2 }} />
          </DialogContent>
        </Dialog>
      )}
    </Container>
  );
};

export default StudentEvaluation;